module.exports = "/images/vendor/flag-icon-css/flags/1x1/gr.svg?0bed56a8b6014fe10fef1d8c24049a17";